import React from "react";
import Select from "react-select";
import { Popup } from "react-leaflet";
import {
  postShop,
  postShopToFigure,
  deleteLinkedShops,
} from "../helpers/queries";
import { useMutation, useQueryClient } from "react-query";
import { Anchor } from "@mantine/core";
import { useDispatch } from "react-redux";
import { addedFloor } from "../helpers/actions/index";

function ShopListPopup({ shopList, item, floorId }) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const saveObject = useMutation(
    (shopId) => {
      return postShop({
        floorId: floorId,
        data: {
          map_settings: {
            leafletID: item.leaflet_obj_id,
            coords: item.coords,
          },
        },
      });
    },
    {
      onSuccess: (data, shopId) => {
        deleteConnectedShops.mutate(shopId);
      },
    }
  );

  const deleteConnectedShops = useMutation(
    (shopId) => {
      return deleteLinkedShops({
        floorId: floorId,
        figureId: item.leaflet_obj_id,
      });
    },
    {
      onSuccess: (data, shopId) => {
        addShopToFigure.mutate(shopId);
      },
    }
  );

  const addShopToFigure = useMutation(
    (shopId) => {
      return postShopToFigure({
        shopId: shopId,
        data: {
          meta: {
            [`floor_${floorId}`]: `leaf_obj_${item.leaflet_obj_id}`,
          },
        },
      });
    },
    {
      onSettled: () => {
        dispatch(addedFloor(floorId));
        queryClient.invalidateQueries("floors");
      },
    }
  );

  return window.appSettings?.frontend === "true" ? (
    <Popup key={item.leaflet_obj_id}>
      <Anchor href={item.shop_link} target="_blank">
        {item.shop_title}
      </Anchor>
    </Popup>
  ) : (
    <Popup
      key={item.leaflet_obj_id}
      closeOnEscapeKey={item?.shop_id ? true : false}
      closeOnClick={item?.shop_id ? true : false}
      closeButton={item?.shop_id ? true : false}
      autoClose={item?.shop_id ? true : false}
    >
      <span hidden>{item.leaflet_obj_id}</span>
      <Select
        className="cc-select"
        onChange={(e) => {
          saveObject.mutate(e.id);
        }}
        getOptionLabel={(option) => option.title}
        getOptionValue={(option) => option.id}
        options={shopList}
        defaultValue={shopList.find((e) => e.id === item.shop_id)}
        placeholder={"Izvelieties veikalu"}
      />
    </Popup>
  );
}

export default ShopListPopup;
